import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment GuideCommentModelItem on GuideCommentModel {
    id
    text
    status
    type
    isPinned
    externalUserEmail
    createdBy {
      subjectId
      name
    }
    createdAt
    updatedBy {
      subjectId
      name
    }
    updatedAt
    closedAt
    closedBy {
      subjectId
      name
    }
    replies {
      id
      comment
      createdBy {
        subjectId
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const ADD_COMMENT = gql(/* GraphQL */ `
  mutation GuideCreateComment($input: GuideCreateCommentInput!) {
    guideCreateComment(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT = gql(/* GraphQL */ `
  mutation GuideDeleteComment($input: GuideDeleteCommentInput!) {
    guideDeleteComment(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT = gql(/* GraphQL */ `
  mutation GuideUpdateComment($input: GuideUpdateCommentInput!) {
    guideUpdateComment(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const UPDATE_STATUS = gql(/* GraphQL */ `
  mutation GuideUpdateCommentStatus($input: GuideUpdateCommentStatusInput!) {
    guideUpdateCommentStatus(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const PIN_COMMENT = gql(/* GraphQL */ `
  mutation GuidePinComment($input: GuidePinCommentInput!) {
    guidePinComment(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const ADD_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation GuideCreateCommentReply($input: GuideCreateCommentReplyInput!) {
    guideCreateCommentReply(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation GuideUpdateCommentReply($input: GuideUpdateCommentReplyInput!) {
    guideUpdateCommentReply(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation GuideDeleteCommentReply($input: GuideDeleteCommentReplyInput!) {
    guideDeleteCommentReply(input: $input) {
      guideCommentModel {
        ...GuideCommentModelItem
      }
    }
  }
`);
